<template>
  <div class="order-delivery">
    <CountrySelector/>
    <CountryMessage/>
    <TypeSelector/>
    <component v-if="getDeliveryTypeSelected !== undefined" :is="getComponentTypeName"/>
    <ErrorMessage
      v-if="!getMovingStatus.success"
      :errors="[getMovingStatus.message]"
    ></ErrorMessage>
    <SuccessMessage
      v-else
      :messages="[getMovingStatus.message]"
    ></SuccessMessage>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
import CountrySelector from './Delivery/CountrySelector'
import TypeSelector from './Delivery/TypeSelector'
import PickUpType from './Delivery/PickUpType'
import DoorType from './Delivery/DoorType'
import RussianPostType from './Delivery/RussianPostType'
import CountryMessage from './Delivery/CountryMessage'
import ErrorMessage from './ErrorMessage'
import SuccessMessage from './SuccessMessage'

export default {
    name: 'Delivery',
    components: {
      SuccessMessage,
      ErrorMessage,
      CountrySelector,
      TypeSelector,
      PickUpType,
      DoorType,
      RussianPostType,
      CountryMessage
    },
    computed: {
      ...mapGetters('order', [
        'getDeliveryTypeSelected',
        'getMovingStatus'
      ]),
      getComponentTypeName: function () {
        switch (this.getDeliveryTypeSelected.code) {
          case 'pickup':
            return 'PickUpType'
          case 'door':
            return 'DoorType'
          case 'russianPost':
            return 'RussianPostType'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Order/Delivery.vue